export default {"src":"/_next/static/media/icon-favorite-normal.a2ddfba0.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};